export enum StoreActionType {
  load,
  upsert,
  test
}
